import { Controller } from "@hotwired/stimulus"

// Registration convenience: as the visitor types their own name, the same
// value is mirrored live into the organization name field, since most
// signups here are a single person naming their own business. Mirroring
// stops the moment the visitor types into the target field directly, so it
// only ever acts as a starting point they stay free to override (e.g. a
// trade name that differs from their own name).
export default class extends Controller {
  static targets = ["source", "target"]

  connect() {
    this.touched = this.targetTarget.value.trim() !== ""
  }

  mirror() {
    if (this.touched) return
    this.targetTarget.value = this.sourceTarget.value
  }

  markTouched() {
    this.touched = true
  }
}
